export default __webpack_public_path__ + "static/media/Pedestal Icons_Classic.3692ffae.svg";